import { render } from "./IntegrationsListItem.vue?vue&type=template&id=22361e9b&scoped=true"
import script from "./IntegrationsListItem.vue?vue&type=script&lang=js"
export * from "./IntegrationsListItem.vue?vue&type=script&lang=js"

import "./IntegrationsListItem.vue?vue&type=style&index=0&id=22361e9b&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22361e9b"]])

export default __exports__